import PopupComponent from '../PopupComponent';
import CartController from './cart-controller';
import CheckoutContact from './CheckoutForm';
import each from 'lodash/each';
import map from 'lodash/map';

export default class CheckoutPopup extends PopupComponent {
	constructor() {
		super({
			element: '.popup--checkout',
			elements: {
				content: '.popup__content',
				itemList: '.popup__checkout-product-wrapper',
				btnCheckout: '#checkout',
				shopping: {
					subtotal: '#shopping-subtotal',
					delivery: '#shopping-delivery',
					selectedCountry: '#country',
					total: '#shopping-total',
				},
			},
		});
		this.elements.goBack = document.querySelector('.popup__cross--go-back');
	}

	create() {
		super.create();
		this.checkoutContact = new CheckoutContact({
			element: '.popup__checkout',
		});
		this.checkoutContact.create();
	}

	createHTML(product) {
		return `
		<div class="popup__checkout-item" data-guid="${product.guid}">
			<span class="popup__checkout-item-title">${
				product.title
			}<span class="popup__checkout-item-subtitle">(${product.size.name.slice(
			0,
			3
		)} - ${product.frame.name})</span>
			</span>
			<span class="popup__checkout-item-price">${
				product.quantity > 1 ? product.quantity + 'x - ' : ''
			} ${product.pricestring}</span>
		</div>`;
	}

	addProductToDOM(product) {
		const itemHtml = this.createHTML(product);
		this.elements.itemList.insertAdjacentHTML('beforeend', itemHtml);
	}

	addEventListeners() {
		super.addEventListeners();
		if (this.checkoutContact) this.checkoutContact.addEventListeners();
		this.elements.goBack.addEventListener('click', () => {
			this.$emit('viewShoppingCart');
			this.hide(false);
		});
		this.elements.btnCheckout.addEventListener('click', () => {
			this.checkoutContact.submitForm();
		});
	}

	updateUi() {
		this.elements.shopping.subtotal.innerHTML =
			CartController.getSubtotalPriceString();
		this.elements.shopping.delivery.innerHTML =
			CartController.getDeliveryPriceString();
		this.elements.shopping.total.innerHTML =
			CartController.getTotalPriceString();
		this.checkoutContact.updateUi();
	}

	show() {
		super.show();
		this.$emit('stopScroll');
		this.elements.itemList.innerHTML = '';

		const cartItems = CartController.getCartItems();
		each(cartItems, (product) => {
			this.addProductToDOM(product);
		});
		this.updateUi();
	}

	hide(startScroll = true) {
		super.hide();
		if (startScroll) this.$emit('startScroll');
	}
}
